// Model descriptions mapping
export const modelDescriptions = {
    //'gpt-4o': 'Fast, intelligent, flexible GPT model.',
    'gpt-4.1': 'Fast, highly intelligent model with largest context window.',
    'gpt-5': 'The best model for coding and agentic tasks across domains.',
    'gpt-5-mini': 'A faster, cost-efficient version of GPT-5 for well-defined tasks.',
    //'gpt-5-nano': 'Fastest, most cost-efficient version of GPT-5.',
    //'gpt-o1': 'Previous full o-series reasoning model.',
    'gpt-o3': 'Reasoning model for complex tasks, succeeded by GPT-5.',
    'claude-opus': 'Hybrid reasoning model that pushes the frontier for coding and AI agents, featuring a 200K context window.',
    'claude-sonnet': 'Hybrid reasoning model with superior intelligence for high-volume use cases, and 200K context window.',
    'claude-haiku': 'Fastest model, delivering advanced coding, tool use, and reasoning at an accessible price.',
    'gemini-2.5-pro': 'The most advanced model yet, excelling at coding and complex prompts.',
    'gemini-2.5-flash': 'The most efficient workhorse model designed for speed and low-cost.'
};

// Models that don't show temperature parameter
export const modelsWithoutTemperature = [
    'gpt-5',
    'gpt-5-mini',
    'gpt-5-nano',
    'gpt-o1',
    'gpt-o3'
];